export enum Events {
    BasketAdd = 'basketAdd',
    FocusSearch = 'focusSearch',
}
